var map = {
	"./11.png": 8492,
	"./11111.png": 7213,
	"./adhar1.png": 7704,
	"./approve.png": 5403,
	"./arrow_up.png": 6360,
	"./bb.png": 7772,
	"./bg.png": 4145,
	"./booster.png": 1626,
	"./box_a.png": 6689,
	"./box_a1.png": 9317,
	"./box_b.png": 5146,
	"./box_b1.png": 7878,
	"./capping.png": 685,
	"./d_team.png": 1666,
	"./direct_bonus.png": 8620,
	"./first.png": 9716,
	"./gift.png": 5330,
	"./graph.png": 3559,
	"./green.png": 1851,
	"./immigration.png": 7541,
	"./lb.png": 8724,
	"./link.png": 7616,
	"./logo_one.png": 4671,
	"./logo_text.png": 5369,
	"./logo_two.png": 4289,
	"./moneyhand.png": 3154,
	"./only_logo.png": 8941,
	"./orange.png": 3279,
	"./package.png": 8558,
	"./pool.png": 2289,
	"./profit.png": 7952,
	"./purple.png": 774,
	"./qwerty.png": 8431,
	"./red.png": 6156,
	"./skyblue.png": 2260,
	"./table_icon_1.png": 3948,
	"./table_icon_2.png": 647,
	"./total_team.png": 3038,
	"./totalrebirth.png": 5797,
	"./trophy.png": 1247,
	"./up.png": 3242,
	"./usericon.png": 1976,
	"./wallet.png": 2106,
	"./website/About-bg-new.png": 8761,
	"./website/ERC-20.png": 7733,
	"./website/Footer.png": 2105,
	"./website/Rectangle 7.png": 8381,
	"./website/Tokenomics.png": 8622,
	"./website/about-bg.png": 1287,
	"./website/about-img.png": 3455,
	"./website/advantage-bg.png": 5474,
	"./website/advantage-img.png": 640,
	"./website/bep-20token.png": 2617,
	"./website/facebook-icon.png": 717,
	"./website/faq-1.png": 6763,
	"./website/faq-2.png": 3236,
	"./website/faq.png": 2378,
	"./website/favicon-2nd.png": 8813,
	"./website/logo.png": 5015,
	"./website/mission.png": 2360,
	"./website/road-map-img.png": 3604,
	"./website/road-new.png": 7475,
	"./website/scroll-img-bg.png": 2565,
	"./website/smart-chain.png": 9837,
	"./website/telegram-icon.png": 4016,
	"./website/text-image.png": 9868,
	"./website/tokinomics.png": 8883,
	"./website/twitter-icon.png": 5348,
	"./website/vision-new-bg.png": 3244,
	"./website/vision.png": 7519,
	"./website/you-tube.png": 6910,
	"./yellow.png": 7635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4071;